import React from 'react';

function Chat() {
  return (
    <section className="tc-chat-style1">
      <div className="container">
        <div className="content">
          <a href="#" className="xl-text">
            seeca.pk@gmail.com
          </a>
          <h5 className="mb-50 lh-5">
            دعنا نعش معك احلامك <br /> لتصبح حقيقة
          </h5>
        </div>
      </div>
      <img src="/home1/assets/img/c_line4.png" alt="" className="c-line wow" />
    </section>
  );
}

export default Chat;
